import React, { useState } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import { makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { makePutRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 500,
  borderRadius: 2,

  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function CreateNote({
  setCreateNote,
  updateTodo = false,
  setNotesList = false,
  setNoteRow = false,
  editNote = false,
  op_id = false,
  setEdit,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modelOpen, setModelOpen] = useState(true)
  const handleModelClose = () => {
    setModelOpen(false)
    setCreateNote(false)
    reset()
  }

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      Titre: editNote?.Titre || '',
      Details: editNote?.Details || '',
    },
  })

  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
    }
    if (editNote) {
      const response = await makePutRequest(
        urls.noteOperations + editNote.id + '/',
        payload,
        {},
        true,
      )
      if (response.status === 200) {
        // setNotesList((notesList) => [...notesList, response.data])
        updateTodo()
        if (setNoteRow) setNoteRow(response.data)
        handleModelClose()
      }
    } else {
      if (op_id) payload = { ...payload, OpfiId: op_id }
      const response = await makePostRequest(urls.noteOperations, payload, {}, true)
      if (response.status === 201) {
        if (setNotesList) setNotesList((notesList) => [...notesList, response.data])
        if (setNoteRow) setNoteRow(response.data)
        updateTodo()
        handleModelClose()
      }
    }
  }

  return (
    <>
      <Modal
        open={modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ '.nounotem': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box sx={mstyle} className="nounotem">
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {editNote ? t('mesToDo.editNote') : t('mesToDo.newNote')}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rules={{ required: true }}
                        name="Titre"
                        label={t('mesToDo.fieldNoteTitle')}
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rows={4}
                        multiline
                        rules={{ required: true }}
                        name="Details"
                        label={t('mesToDo.fieldNote')}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} type="submit">
                        {t('mesToDo.validate')}
                      </Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
